import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { TranslateService } from '@ngx-translate/core';
import { Cookies } from 'src/app/shared/constants/cookie.constants';
import { SharedModule } from 'src/app/shared/modules/shared';

@Component({
  selector: 'app-desktop-popup',
  standalone: true,
  imports: [MatButtonModule, MatDialogContent, MatIconModule, MatDividerModule, SharedModule],
  templateUrl: './desktop-popup.component.html',
  styleUrl: './desktop-popup.component.scss'
})
export class DesktopPopupComponent {
  readonly dialogRef = inject(MatDialogRef<DesktopPopupComponent>);
  readonly data = inject<any>(MAT_DIALOG_DATA);

  readonly translate = inject(TranslateService);

  readonly appStoreUrl = 'https://apps.apple.com/us/app/ikonnect/id6769554623';

  readonly googlePlayUrl = 'https://play.google.com/store/apps/details?id=com.ikonnect.app';

  private readonly badgeBaseUrl = 'https://ikonnectdevstorage01.blob.core.windows.net/media/';

  get language(): 'en' | 'fr' {
    return this.translate.currentLang?.toLowerCase().startsWith('fr') ? 'fr' : 'en';
  }

  get appStoreBadge(): string {
    return `${this.badgeBaseUrl}app-store-badge-black-${this.language}.png`;
  }

  get googlePlayBadge(): string {
    return `${this.badgeBaseUrl}google-play-badge-black-${this.language}.png`;
  }

  close(): void {
    this.dialogRef.close();
  }

  dontShowAgain(): void {
    this.dialogRef.close(Cookies.SEEN_DESKTOP_WARNING);
  }
}
